import type { ReactNode } from 'react'

import { Button } from '@gto/ui/button'

import { AppDialog } from '@/components/app-dialog'

type ConfirmDialogProps = {
  open: boolean
  title: ReactNode
  description?: ReactNode
  confirmLabel: ReactNode
  cancelLabel?: ReactNode
  confirmColor?: 'primary' | 'error' | 'warning' | 'info'
  loading?: boolean
  onConfirm: () => void
  onCancel: () => void
  children?: ReactNode
}

export const ConfirmDialog = ({
  open,
  title,
  description,
  confirmLabel,
  cancelLabel = 'Cancel',
  confirmColor = 'primary',
  loading = false,
  onConfirm,
  onCancel,
  children,
}: ConfirmDialogProps) => {
  return (
    <AppDialog
      open={open}
      width={380}
      onClose={onCancel}
    >
      <AppDialog.Header
        subtitle={description}
        title={title}
      />
      {children != null && <AppDialog.Body>{children}</AppDialog.Body>}
      <AppDialog.Footer>
        <Button
          disabled={loading}
          onClick={onCancel}
        >
          {cancelLabel}
        </Button>
        <Button
          color={confirmColor}
          disabled={loading}
          variant="contained"
          onClick={onConfirm}
        >
          {confirmLabel}
        </Button>
      </AppDialog.Footer>
    </AppDialog>
  )
}
